module.exports = __webpack_public_path__ + "static/img/2-title.d068c70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-title.png
// module id = Dd2I
// module chunks = 0